<template>
    <div class="max-w-500 w-full h-full mx-auto pb-16 relative" data-cy="container_home_main">
        <div v-if="isShowGoldenQuestion" class="fixed right-4 top-[430px] z-50" data-cy="btn_home_golden_question" @click="goSurveyPage()">
            <img :src="gifUrl()" class="w-24 h-24" alt="icon golden question" data-cy="img_home_golden_question">
        </div>
        <WelcomePoint
            data-cy="component_home_welcome_point"
            :isShowPoint="isShowPoint" />
        <div class="bg-white" data-cy="container_home_dashboard">
            <DashboardSlider
                class="pb-4"
                data-cy="container_home_dashboard_slider"
                :apiConfig="dashboardConfig"
                @onLoaded="onLoadSuccess('dashboard')" />
        </div>
        <div class="bg-a-blue-f2f5ff w-full h-3"></div>
        <MemberCode
            data-cy="component_home_member_code"
            @onTimeExpired="onTimeExpired()"
            v-if="isShowMemberCode" />
        <div class="bg-white pt-4 pb-10" data-cy="container_home_category">
            <CategorySearchList
                ref="cate-list"
                data-cy="container_home_category_list"
                :categoryConfig="categoryConfig"
                @onLoaded="onLoadSuccess('campaign')"
            ></CategorySearchList>
        </div>
        <MenuBar />
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
//hepler
import DatetimeHelper from '@/helper/DatetimeHelper.js';
import Account from '@/helper/AccountHelper.js';
//mixin
import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//component
import MenuBar from '@/components/Layout/MenuBar/MenuBar.vue';
import WelcomePoint from '../component/WelcomePoint.vue';
import MemberCode from '../component/MemberCode.vue';
import DashboardSlider from '@/components/Dashboard/DashboardSlider.vue';
import CategorySearchList from '@/module/List/component/CategoryList/CategorySearchList.vue';
//service
import { CategoryConfigBuilder } from '@/core/Campaign/model/CategoryConfigModel.js';
// import HomeService from '../service/HomeService.js';
import { SubDashboardConfigBuilder } from '@/core/Campaign/config/DashboardConfigModel.js';
import BzbsDashboard from '@/core/Campaign/service/BzbsDashboard.js';
import { UserFlag } from '@/core/UserLevel/UserFlag.js';
import { UserLevel } from '@/core/UserLevel/UserLevelDetail.js';

export default {
    name: "Home",
    mixins: [AuthPageMixin, AuthStatusMixin, LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        MenuBar,
        WelcomePoint,
        MemberCode,
        DashboardSlider,
        CategorySearchList,
    },
    data: function() {
        return {
            dashboardConfig: "bblprivilege_home",
            dashboardFlag1Config: "bblprivilege_new_customer",
            dashboardGoldenQuestionConfig: "bbl_golden_question",
            categoryConfig: null,

            loadingStatus: {
                dashboard: false,
                campaign: false,
            },

            // isShowPoint: false,
            isShowMemberCode: false,
            isUserFlag1: false,

            arrDashboardFlag1: [],
            arrDashboardGoldenQuestion: [],

            isShowGoldenQuestion: false,
        };
    },
    created: async function() {
        this.tracking.screenName('home');
        this.tracking.event('home', 'view_home', null, null);

        this.setScrollLoadMore();
        this.initialCategory();
        // await this.getConfig();

        //flag1
        this.arrDashboardFlag1 = await this.getDashboardFlag1();
        this.checkUserFlag1();

        // get dashboard golden question
        this.arrDashboardGoldenQuestion = await this.getDashboardGoldenQuestion();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        initialCategory: function () {
            var configStr = ConfigManager.getCategoryMenuHome();
            var categoryConfig = new CategoryConfigBuilder()
                .setConfig(configStr)
                .setLocale(this.localeCode)
                .create();

            this.categoryConfig = categoryConfig;
        },
        loadMore: function() {
            this.$refs['cate-list'].loadMore();
        },
        // getConfig: function () {
        //     return new Promise((resolve) => {
        //         HomeService.apiGetMainConfig()
        //             .subscribe({
        //                 next: (res) => {
        //                     console.log('config', res)
        //                     this.isShowPoint = res.main.point;
        //                     resolve(true);
        //                 },
        //                 error: (err) => {
        //                     this.errorApi(err);
        //                     resolve(null);
        //                 }
        //             });
        //     });
        // },
        //#region flag1
        checkUserFlag1: function(){
            let userFlag1 = new UserFlag();
            let userLevel = new UserLevel();

            let currentDate = new Date();
            let joinDate = Account.getUserJoinDate();
                joinDate = DatetimeHelper.unixTimestampToDate(joinDate);

            let dayDiff = DatetimeHelper.calDiffInDay(joinDate, currentDate);

            console.log('joinDate', joinDate);
            console.log('dayDiff', dayDiff);
            console.log('getUserLevel', Account.getUserLevel())
            console.log('userLevel', userLevel.isFlag32())

            this.isUserFlag1 = userFlag1.isFlag1();
            if(this.isUserFlag1 && dayDiff == 0 && userLevel.isFlag32()){
                if(this.arrDashboardFlag1){
                    this.checkShowFlag1();
                }
            }
        },
        getDashboardFlag1: function() {
            return new Promise((resolve) => {
                var configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                var params = configBuilder.create().getParams();
                BzbsDashboard.apiGetSubDashboard(params, this.dashboardFlag1Config)
                    .subscribe({
                        next: (res) => {
                            console.log('flag1', res);
                            //this.arrDashboardFlag1 = res;
                            resolve(res);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            console.log(err);
                            resolve(null);
                        }
                    });
            });

        },
        getDashboardGoldenQuestion: function() {
            return new Promise((resolve) => {
                var configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                var params = configBuilder.create().getParams();
                BzbsDashboard.apiGetSubDashboard(params, this.dashboardGoldenQuestionConfig)
                    .subscribe({
                        next: (res) => {
                            console.log('golden question', res);
                            if (res && res.length > 0) {
                                this.isShowGoldenQuestion = true;
                            }
                            //this.arrDashboardGoldenQuestion = res;
                            resolve(res);
                        },
                        error: (err) => {
                            // this.errorApi(err);
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
        goSurveyPage: function() {
            this.tracking.event('home_GoldenQuiz', 'click_Quiz', null, null);
            let surveyId = this.arrDashboardGoldenQuestion[0].id;
            this.$router.push({ name: 'survey', params: { surveyId: surveyId } });
        },
        checkShowFlag1: function(){
            if(this.arrDashboardFlag1.length <= 0) return;

            let currentDate = new Date();
            let start = DatetimeHelper.unixTimestampToDateNotPlus(this.arrDashboardFlag1[0].startDate);
            let end = DatetimeHelper.unixTimestampToDateNotPlus(this.arrDashboardFlag1[0].endDate);

            if(currentDate >= start && currentDate <= end){
                this.isShowMemberCode = true;
                console.log('currentDate', currentDate)
                console.log('start', start);
                console.log('end', end);
            }

        },
        //#endregion flag1
        onLoadSuccess: function(api) {
            if (!this.loadingStatus[api]) {
                this.loadingStatus[api] = true;
                let found = false;
                for (let i in this.loadingStatus) {
                    if (!this.loadingStatus[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    this.modal.loadingModal.hide();
                }
            }
        },
        sendError: function (error) {
            this.$emit('onError', error);
        },
        onTimeExpired: function(){
            this.isShowMemberCode = false;
        },
        gifUrl: function() {
            var appId = ConfigManager.getAppId();
            var getConfig = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/golden-question/ic-golden-question.gif`;
            
            return getConfig;
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
